// ... your code that runs before foundation initiation

// Fix for foundation stylesheets being picked up as "null" or "not an object",
// implementation from here: http://foundation.zurb.com/forum/posts/3189-foundation-5-orbit-slider-ie8-issue
(function($) {
    'use strict';

    if (!Foundation.stylesheet) {
        Foundation._style_element = $('<style></style>').appendTo('head')[0];
        Foundation.stylesheet = Foundation._style_element.styleSheet;

        if (Foundation.stylesheet) {
            Foundation.stylesheet.cssRules = {
                length: 0
            };

            Foundation.stylesheet.insertRule = function(rule, index) {
                var media;
                var mediaMatch;
                var mediaRegex;
                var namespace;
                var ruleMatch;
                var ruleRegex;
                mediaRegex = /^\s*@media\s*(.*?)\s*\{\s*(.*?)\s*\}\s*$/;
                mediaMatch = mediaRegex.exec(rule);
                media = '';

                if (mediaMatch) {
                    media = '@media ' + mediaMatch[1] + ' ';
                    rule = mediaMatch[2];
                }

                ruleRegex = /^\s*(.*?)\s*\{\s*(.*?)\s*\}\s*$/;
                ruleMatch = ruleRegex.exec(rule);
                namespace = '' + media + ruleMatch[1];
                rule = ruleMatch[2];

                return this.addRule(namespace, rule);
            };
        } else if (window.console) {
            console.log('Could not fix Foundation CSS rules...');
        }
    }
})(jQuery);

// Accessible image sprites (modificat):
// https://www.paciellogroup.com/blog/2012/08/notes-on-accessible-css-image-sprites/

function HCTest() {
    'use strict';

    var objDiv;
    var strColor;
    var objFlag;

    // reference to img element used to check if images are disabled
    objFlag = document.getElementById('flag');
    if (objFlag === null) {
        return;
    }

    // Create a test div
    objDiv = document.createElement('div');

    // Set its color style to something unusual
    objDiv.style.color = 'rgb(31,41,59)';

    // Attach to body so we can inspect it
    document.body.appendChild(objDiv);

    // Use standard means if available, otherwise use the IE methods

    strColor = document.defaultView ? document.defaultView.getComputedStyle(objDiv, null).color : objDiv.currentStyle.color;

    // get rid of extra spaces in result
    // strColor = strColor.replace(/ /g,"");

    // Delete the test DIV

    document.body.removeChild(objDiv);

    // Check if we got back what we set (strColor== ??) If not we are in high contrast mode
    // Use .offsetwidth and .readyState (for IE) to check if images are enabled
    // If either images are disabled or high contrast is enabled (or both) the CSS stylesheet link will not be added to the page and the visually hidden text will be displayed in place of the missing background image

    if (!(((objFlag.offsetWidth === 1 && objFlag.readyState === 'complete') || (objFlag.offsetWidth === 1 && objFlag.readyState === undefined)) && (strColor === 'rgb(31,41,59)' || strColor === 'rgb(31, 41, 59)'))) {

        var objHead = document.getElementsByTagName('head');
        var objCSS = objHead[0].appendChild(document.createElement('link'));
        objCSS.rel = 'stylesheet';
        objCSS.href = '/media/css/alt.css';
        // objCSS.type = 'text/css';
    }
}

// Safely initiate foundation now
$(document).foundation();

// the rest of your code

$(window).load(function() {
    'use strict';

    // accessible image sprites
    HCTest();


});


// mobile-nav
(function() {

    var mqm = window.matchMedia('(max-width: 40em)');

    // get the button and menu nodes
    var button = document.querySelector('[aria-label="site"] button');
    var menu = button.nextElementSibling;

    // set initial (closed menu) states
    button.setAttribute('aria-expanded', 'false');
    button.hidden = false;
    if (mqm.matches && typeof (menu) !== 'undefined') {
        menu.hidden = true;
    }

    $( window ).resize(function() {
        /*if (mqm.matches) {
            menu.hidden = true;
        }
        else {
            menu.hidden = false;
        }*/
        //if($( window ).width() > 620){
        if (window.matchMedia('(min-width: 620px)').matches && typeof (menu) !== 'undefined') {
            menu.hidden = false;
        }
    });

    button.addEventListener('click', function() {
        // toggle menu visibility
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));

        if (typeof (menu) !== 'undefined') {
            menu.hidden = expanded;
        }
    });

})();



$(document).ready(function() {
    'use strict';

    // feature.js
    if (feature.svg) {
        $('html').addClass('svg');
    }

   //cookies
   /*$('.ihavecookies_change').click(function(event){
    event.preventDefault();
    $('body').ihavecookies(options, 'reinit');
    });*/

    // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
    // bind a click event to the 'skip' link
    $(".skip-link").click(function(event){

        // strip the leading hash and declare
        // the content we're skipping to
        var skipTo="#"+this.href.split('#')[1];

        // Setting 'tabindex' to -1 takes an element out of normal
        // tab flow but allows it to be focused via javascript
        $(skipTo).attr('tabindex', -1).on('blur focusout', function () {

            // when focus leaves this element,
            // remove the tabindex attribute
            $(this).removeAttr('tabindex');

        }).focus(); // focus on the content container
    });

    // canvi svg per png
    if (!feature.svg) {
        var imgs = document.getElementsByTagName('img');
        var endsWithDotSvg = /.*\.svg$/;
        var i = 0;
        var l = imgs.length;
        for (; i !== l; ++i) {
            if (imgs[i].src.match(endsWithDotSvg)) {
                imgs[i].src = imgs[i].src.slice(0, -3) + 'png';
            }
        }
    }

    // smooth scroll top
    $(window).scroll(function() {
        if ($(this).scrollTop() > 800) {
            $(".top").fadeIn()
        } else {
            $(".top").fadeOut()
        }
    });
    $(function() {
      $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
      });
    });

    // marcar element actiu del menú
    $('.main-nav [aria-current="page"]').append('<span class="js-border"></span>');

    /*------------------*/
  /* Lazy load images */
  /*------------------*/
      $("img.lazy:not('img.noLazy')").show().lazyload({
        effect: "fadeIn"
    //      failure_limit: 2,
    //      threshold: 400
    //      skip_invisible: false
      });
    $(function() {
        $("img.lazySlider").lazyload({
            event : "sporty"
        });
    });

    $(window).bind("load", function() {
        var timeout = setTimeout(function() {
            $("img.lazySlider").trigger("sporty");
        }, 100);
    });

      $("img.lazyNoticies").lazyload({
        effect: "fadeIn",
        threshold: 300,
        failure_limit: 5//
      });
      /*----------------------*/
      /* END Lazy load images */
      /*----------------------*/

    $( ".highlight__title a" ).hover(
      function() {
        $( ".highlight .opacity" ).addClass( "hover" );
      }, function() {
        $( ".highlight .opacity" ).removeClass( "hover" );
      }
    );
    // millora de formularis
    // $('.form-wrapper').append('<span class="form-border"></span>');

    // fixed nav
    // $(function() {
    //   var stickyHeaderTop = $('.main-nav').offset().top;
    //   $(window).scroll(function() {
    //     if ($(window).scrollTop() > stickyHeaderTop) {
    //       $('.main-nav').addClass('sticky');
    //       $('body').addClass('sticky-nav');
    //     } else {
    //       $('.main-nav').removeClass('sticky');
    //       $('body').removeClass('sticky-nav');
    //     }
    //   });
    // });
    $(window).load(function() {
        //var timeout = setTimeout(function() {

            $("body").addClass("load");
        //}, 100);
    });
    //linies fitxa noticia
    $( window ).resize(function() {
        if (window.matchMedia('(min-width:900px)').matches) {
            var ContingutBox = $('.article-wrapper');
            $ ('.aside__border').css({ height: ContingutBox.height() });
        }else{
            $ ('.aside__border').css('height','auto');
        }

    });
    if (window.matchMedia('(min-width: 900px)').matches) {
        var ContingutBox = $('.article-wrapper');
        $ ('.aside__border').css({ height: ContingutBox.height() });
    }else{
        $ ('.aside__border').css('height','auto');
    }

    $(".news-item img").click(function(){
          var url = $(this).parent('div').find("h2").children('a').attr("href");

          if(url != undefined){
              window.location= url;
          }
          //return false;
        });
    $(".news-item img").css({"cursor": "pointer"});

    //cercador
     $('.menu .cercador a').on('click', function(){
        if ( $( this ).hasClass( "is-active" ) ) {
            $(this).removeClass('is-active');
            $('#search__box').removeClass('is-active').addClass('is-off');
        }else{
            $('#search__box').removeClass('is-off').addClass('is-active');
            $(this).addClass('is-active');
            $('#search__box input').focus();
        }
        return false;
    });
    $('#search__box .search-form__clear-input').on('click', function(){
        $('#search__box input').val('');
        $('#search__box input').focus();
        return false;
    });
    $('.cerca-dades .search-form__clear-input').on('click', function(){
        $('.cerca-dades input').val('');
        $('.cerca-dades input').focus();
        return false;
    });
    //menú desplegat per table
    $('.isTabled .menu .has-submenu > a').on('click', function(){
        var submenu = $(this).next('.submenu');
        if($(submenu).is(":visible")){
            $(submenu).css('display','none');
        }else{
            $(submenu).css('display','block');
        }
        return false;
    });

    $(window).trigger('scroll');
});
